var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 4.81717H8.66683V6.06747H7.3335V4.81717ZM7.3335 7.31778H8.66683V11.0687H7.3335V7.31778ZM8.00016 1.69141C4.32016 1.69141 1.3335 4.49209 1.3335 7.94293C1.3335 11.3938 4.32016 14.1945 8.00016 14.1945C11.6802 14.1945 14.6668 11.3938 14.6668 7.94293C14.6668 4.49209 11.6802 1.69141 8.00016 1.69141ZM8.00016 12.9442C5.06016 12.9442 2.66683 10.6999 2.66683 7.94293C2.66683 5.18601 5.06016 2.94171 8.00016 2.94171C10.9402 2.94171 13.3335 5.18601 13.3335 7.94293C13.3335 10.6999 10.9402 12.9442 8.00016 12.9442Z",
    fill: "#A977F9",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.658c43cec882c4189abbacd52670594b.svg";
export { ForwardRef as ReactComponent };